// JavaScript Document
jQuery(document).ready(function($) {
   if(jQuery(".toggle").length > 0){
	$('header .toggle').click(function () {
		$('header').toggleClass('active');
		$('body').toggleClass('open-menu');
		$(".mobile-nav").toggleClass('open');
	});
   }
   if(jQuery(".category-slider").length > 0){
   function collCarousel() {
      var swiper = new Swiper(".category-slider", {
        speed: 1000,
        loop: true,
        behavior: 'smooth',
        slidesPerView: 3,
        spaceBetween: 20,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
         breakpoints: {
              1024: {
                  slidesPerView:3,
                  spaceBetween: 20,
              },
              767: {
                  slidesPerView: 2,
                  spaceBetween: 20,
              },
            320: {
                  slidesPerView: 2,
                  paceBetween: 20,
              }
          }
      });
    }	
    collCarousel();	    
   }
   if(jQuery(".reviews").length > 0){
    function reviewCarousel() {
      var swiper = new Swiper(".reviews", {
        speed: 1000,
        loop: true,
        autoplay: true,
        behavior: 'smooth',
        slidesPerView:1,
        spaceBetween: 10,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }	
    reviewCarousel();
    }
     if(jQuery(".hero-area").length > 0){
    function heroCarousel() {
      var swiper = new Swiper(".hero-area", {
        speed: 1500,
        loop: true,
        autoplay: true,
        behavior: 'smooth',
        slidesPerView:1,
        spaceBetween: 0,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      setTimeout(function() {
        var clr = $('.swiper-slide.ele_swiper.swiper-slide-active').attr('color_ele');
        if (clr == 'b') {
          $('body').addClass('ele_black_coloured');
        } else if (clr == 'w') {          
          $('body').addClass('ele_white_coloured');
        }
      }, 400);

      swiper.on('slideChange', function () {
        setTimeout(function() {
          $('body').removeClass('ele_white_coloured');
          $('body').removeClass('ele_black_coloured');
          var clr = $('.swiper-slide.ele_swiper.swiper-slide-active').attr('color_ele');
          if (clr == 'b') {
            $('body').addClass('ele_black_coloured');
          } else if (clr == 'w') {          
            $('body').addClass('ele_white_coloured');
          }          
        }, 400)
      });
    }	
    heroCarousel();
    }

/*if(jQuery(".ingredients .box").length > 0){
   if ($(window).width() > 1000) {
   $('.box').each(function () {
        var $box = $(this);
        var $readBtn = $box.find('.read-btn');
        var $hideText = $box.find('.hide-text');
        var $h4 = $box.find('h4');
        var h4Width = $h4.width();
        $hideText.css('width', h4Width + 'px');
        $readBtn.css('width', h4Width + 'px');
    });
   }
 }*/
  
  if(jQuery(".read-btn").length > 0){
    $('.read-btn').on('click', function() {
      const $box = $(this).closest('.box');
      // const h4Width = $box.find('h4').width(); 
      if ($box.hasClass('active')) {       
        $box.removeClass('active non-active');       
        $box.find('.hide-text').slideUp().removeClass('non-active');
        $('.box').not($box).removeClass('non-active');
      } else {       
        //$box.find('.hide-text').css('width', h4Width + 'px');
        $('.box.active').removeClass('active non-active');
        $('.box .hide-text').slideUp().removeClass('non-active');
        $box.addClass('active').removeClass('non-active');
        $(this).prev('.hide-text').slideToggle().removeClass('non-active');
        $('.box').not($box).addClass('non-active');
      }      
    });   
  }

  if($(window).width() > 1000) {
     $('div[data-href^="#box-"]').click(function() {
      var targetId = $(this).data('href');
      $('.scent-info > ' + targetId).toggle();
      return false;
    });
  } else {
     $('div[data-href^="#box-"]').click(function () {
        var targetId = $(this).data('href');
        $('.scent .content > ' + targetId).toggle();
        return false;
    });
  }
  
  
  if(jQuery(".heading").length > 0){
    $('.outer-box').hide();
    if($(window).width() > 1000) {
      $('.heading').click(function() {
          var parentLi = $(this).closest('li');
          if (parentLi.hasClass('active')) {
              parentLi.find('.outer-box').hide();
              parentLi.removeClass('active');
              parentLi.removeClass('non-active');
              parentLi.removeAttr('style');
              $('li').not(parentLi).removeClass('non-active');
              $(this).removeClass('active');
          } else {
              $('.outer-box').hide();
              $('li').removeClass('active');
              $('li').not(parentLi).addClass('non-active');
              parentLi.removeClass('non-active');
              parentLi.addClass('active');
              $(this).addClass('active');
              $(this).next('.outer-box').show();
              var liHeight = parentLi.find('.outer-box').is(':visible')
              ? parentLi.find('.outer-box').outerHeight()
              : parentLi.find('.content').outerHeight();
              liHeight += $(this).outerHeight();
              //parentLi.css('height', liHeight + 'px');
              $('li').not(parentLi).removeAttr('style'); 
          }
      });
      $('.outer-box .close').click(function() {
        var parentLi = $(this).closest('li');
        parentLi.find('.outer-box').hide();
        parentLi.removeClass('active');
        $('li').not(parentLi).removeClass('non-active');
      });
    } else {
      $('.heading').click(function() {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).next('.outer-box').hide();
          } else {
            $(this).addClass('active');
            $(this).next('.outer-box').show();
          }
      });
    }
  }  
  
  if(jQuery(".template-index").length > 0){
      var heroBottom = $('.hero-area').offset().top + $('.hero-area').outerHeight();
      var header = $('header');
      var aside = $('aside');
      $(window).scroll(function() {
          if ($(window).scrollTop() >= heroBottom) {
              header.addClass('fixed-hdr');
              aside.addClass('fixed-hdr');
          } else {
              header.removeClass('fixed-hdr');
              aside.removeClass('fixed-hdr');
          }
      });
  }
  if(jQuery(".nav-link").length > 0){
	$(".nav-link").click(function () {
		// Remove active class from all tab items
		$(".nav-link").removeClass("active");
		// Add active class to the clicked tab item
		$(this).addClass("active");

		// Hide all tab contents
		//$(".tab-content").hide();

		// Show the corresponding tab content
		var contentId = $(this).data("content");
		$("#" + contentId).show();

		// Scroll the clicked tab into view
		var tabOffset = $(this).offset().left;
		var menuOffset = $("#top-categories-tabs").offset().left;
		var scrollAmount = tabOffset - menuOffset;
		$("#top-categories-tabs").animate({
			scrollLeft: scrollAmount
		}, "slow");
      var tabOffset = $(this).offset().left;
      var menuOffset = $("#shop-by-chakra").offset().left;
		var scrollAmount = tabOffset - menuOffset;
		$("#shop-by-chakra").animate({
			scrollLeft: scrollAmount
		}, "slow");
	});
  }  
  // Mobile only js
  /*if($(window).width() > 1000) {
    if($('.product-description .box .image').length > 0){
    // Select the second .box and find the child .content
      var $content = $('.box:eq(1) > .content');
       var Height = $content.outerHeight(true);
      var totalHeight = 0;
      // Recursive function to calculate total height of all children and sub-children
      function calculateTotalHeight($element) {
          $element.children().each(function () {
              totalHeight += $(this).outerHeight(true);              
              calculateTotalHeight($(this));
          });
      }
      calculateTotalHeight($content);
     // Use contentHeight as needed
    console.log("Height of .content: " + Height + " pixels");
      // Set the total height to the child .image elements within all .box
      $('.product-description .box .image').css('height', totalHeight + 'px');
     }
  }*/
});



'use strict';
const breakpoint = window.matchMedia('(min-width:991px)');
let mySwiper ;
const breakpointChecker = function () {
    if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
    } else if (breakpoint.matches === false) {
        return enableSwiper();
    }
};
const enableSwiper = function () { 
    mySwiper = new Swiper(".scentinfo", {          
         speed: 1000,
         loop: true,        
         behavior: 'smooth',           
         slidesPerView: 1,
         spaceBetween: 13,
      }); 
  mySwiper = new Swiper(".supplier", {          
         speed: 1000,
         loop: true,        
         behavior: 'smooth',           
         slidesPerView: 1,
         spaceBetween: 13,
      }); 
};
breakpoint.addListener(breakpointChecker);
breakpointChecker();